module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_15.7324920e.png";